<template>
  <div class="empty-state">
    <div class="no-funds-header-image"><img src="@/assets/saving-zone/no-funds-header-image.svg" /></div>
    <div class="content">
      <div class="no-funds-header-texts">
        <div class="r-typo-headline-label no-funds-title">קופת גמל להשקעה</div>
        <div class="r-typo-headline no-funds-title">למה לחסוך איתנו?</div>
      </div>
      <div class="text">
        אפשר לפתוח חיסכון דרכנו ולהעביר אליו בקלות סכומים משתנים ישירות מהתזרים.
        בלי טופסולוגיה. בלי כאב ראש. בכמה דקות.
      </div>
      <riseup-button class="open-kgl-button" title="לפתיחת קופה ב-5 דק׳!" :action="openKGLClicked"></riseup-button>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import OpenKglFlowAction
  from '@/pages/responsive-pages/authenticated/navigation-pages/saving-zone/components/OpenKglFlowAction';
import Segment from '@/Segment';

export default {
  name: 'EmptyState',
  mixins: [OpenKglFlowAction],
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  methods: {
    openKGLClicked() {
      Segment.trackUserInteraction('MySavings_VpStartSaveKGL');
      this.openKGLFlow();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../scss/mixins';
@import '~base-ui/src/scss/riseup-colors';

.empty-state {
  background-color: $riseup_white;

  .no-funds-header-image {
    margin-bottom: 30px;

    img {
      max-width: 100%;
    }
  }

  .no-funds-header-texts {
    .no-funds-title {
      margin-bottom: 10px;
    }
  }

  .content {
    width: 100%;
    @include responsive-padding;

    .text {
      line-height: 1.5;
      margin-bottom: 50px;
    }
  }

  .open-kgl-button {
    width: 100%;
  }
}
</style>
